import { TemplateRef } from "@angular/core";

export type TPopoverPlacement = 'top' | 'bottom' | 'left' | 'right';
export class CpqPopoverConfig {
  content: TemplateRef<any> | string = '';
  placement: TPopoverPlacement = 'right';
  outsideClick = true;
  isError = false;
  panelClass?: string | string[];

  constructor(options?: Partial<CpqPopoverConfig>) {
    if (!options) return;

    Object.assign(this, options);
  }
}
